/* @flow */
import AdminSisSyncSchoolNotSetupView from './AdminSisSyncSchoolNotSetupView';

export default AdminSisSyncSchoolNotSetupView;
